<template>
  <div class="progress font-34" @click="handlerClick">
    <div v-if="round" class="round">
      <div>
        <span>{{ title }}</span>
      </div>
      <div class="round-progress">
        <canvas :width="size" :height="size"></canvas>
        <div class="fb fb-col fb-main-center fb-cross-center">
          <div>
            <span>{{ current }}</span>
            <span>/</span>
            <span>{{ total }}</span>
          </div>
          <div class="font-24">
            <span>已到</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span>应到</span>
          </div>
        </div>
      </div>
      <div class="statistic-number fb fb-cross-center">
        <ul class="fb fb-row">
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{
              detail.lackCheckInMemberCount || 0
            }}</span>
            <span class="font-28">未打卡</span>
          </li>
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{ detail.lateMemberCount || 0 }}</span>
            <span class="font-28">迟到</span>
          </li>
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{ detail.leaveEarlyMemberCount || 0 }}</span>
            <span class="font-28">早退</span>
          </li>
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{ detail.absentMemberCount || 0 }}</span>
            <span class="font-28">缺勤</span>
          </li>
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{ detail.leaveMemberCount || 0 }}</span>
            <span class="font-28">请假</span>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="line">
      <div>
        <span>{{ title }}</span>
      </div>
      <div class="line-progress fb fb-main-between">
        <common-progress-line
          :total="total === 0 ? 1 : total"
          :current="current"
        ></common-progress-line>
        <div>
          <span>{{ `${current}/${total}` }}</span>
        </div>
      </div>
      <div class="statistic-number fb fb-cross-center">
        <ul class="fb fb-row">
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{
              detail.lackCheckInMemberCount || 0
            }}</span>
            <span class="font-28">未打卡</span>
          </li>
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{ detail.lateMemberCount || 0 }}</span>
            <span class="font-28">迟到</span>
          </li>
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{ detail.leaveEarlyMemberCount || 0 }}</span>
            <span class="font-28">早退</span>
          </li>
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{ detail.absentMemberCount || 0 }}</span>
            <span class="font-28">缺勤</span>
          </li>
          <li class="fb fb-col fb-main-center fb-cross-center">
            <span class="font-28">{{ detail.leaveMemberCount || 0 }}</span>
            <span class="font-28">请假</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import commonProgressLine from './commonProgressLine'
export default {
  name: 'commonProgress',
  components: { commonProgressLine },
  props: {
    round: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    detail: {
      type: Object,
      default: () => {
        return {
          totalMemberCount: 0,
          checkinMemberCount: 0,
          lackCheckInMemberCount: 0,
          lateMemberCount: 0,
          leaveEarlyMemberCount: 0,
          absentMemberCount: 0,
          leaveMemberCount: 0
        }
      }
    }
  },
  data() {
    return {
      size: 124, // 圆形进度条宽度和高度
      canvasEl: null, // 进度条画布
      cacheCanvas: null, // 进度条画布（临时）
      lineWidth: 8 //  进度条宽度
    }
  },
  computed: {
    computedProgress() {
      let _progress = 0
      _progress =
        Math.ceil(
          (this.detail.checkInMemberCount * 1000) / this.detail.totalMemberCount
        ) / 10
      return _progress
    },
    total() {
      return this.detail.totalMemberCount || 0
    },
    current() {
      return this.detail.checkInMemberCount || 0
    }
  },
  watch: {
    round() {
      this.init()
    },
    computedProgress() {
      this.methodDrowProgress()
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {
      if (this.round) {
        this.cacheCanvas = document.createElement('canvas')
        this.cacheCanvas.width = this.size
        this.cacheCanvas.height = this.size
        this.canvasEl = this.$el.getElementsByTagName('canvas')[0]
        this.methodDrowProgress()
      }
    },
    handlerClick(e) {
      this.$emit('click', e)
    },
    methodDrowProgress() {
      if (!this.cacheCanvas) {
        return
      }
      let _ctx = this.cacheCanvas.getContext('2d')
      let _offset = this.size / 2
      // 保存状态(1)
      _ctx.save()
      _ctx.lineWidth = this.lineWidth
      _ctx.lineCap = 'round'
      _ctx.translate(_offset, _offset)
      _ctx.clearRect(-_offset, -_offset, this.size, this.size)
      _ctx.rotate(-Math.PI / 2)

      // 绘制进度条底部圆形
      _ctx.beginPath()
      _ctx.arc(0, 0, this.size / 2 - this.lineWidth, 0, Math.PI * 2, true)
      _ctx.strokeStyle = '#dfdfe0'
      _ctx.stroke()

      // 绘制进度条
      _ctx.beginPath()
      _ctx.arc(
        0,
        0,
        this.size / 2 - this.lineWidth,
        0,
        (Math.PI * 2 * this.computedProgress) / 100,
        false
      )
      _ctx.strokeStyle = '#006AFE'
      _ctx.stroke()

      // 返回到状态(1)
      _ctx.restore()
      if (!this.canvasEl) {
        return
      }
      let _ctx2 = this.canvasEl.getContext('2d')
      _ctx2.clearRect(0, 0, this.size, this.size)
      _ctx2.drawImage(this.cacheCanvas, 0, 0, this.size, this.size)
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.progress {
  width: 100%;
  .round {
    height: 252px;
    padding: 10px 0;
    > .round-progress {
      position: relative;
      margin-top: 5px;
      height: 144px;
      > * {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .line {
    height: 134px;
    padding: 10px 0;
    > div {
      height: 20px;
      line-height: 20px;
      &.line-progress {
        margin-top: 10px;
        > div:first-child {
          width: 250px;
        }
      }
    }
  }
}

.statistic-number {
  margin-top: 10px;
  border-top: 1px solid #d8d8d8;
  height: 60px !important;
  ul {
    padding: 5px 16px;
    width: 100%;
    li {
      height: 30px;
      width: 25%;
      border-right: 1px solid #d8d8d8;
      span {
        display: inline-block;
        height: 20px;
      }
    }
    & > li:last-child {
      border: 0;
    }
  }
}
</style>
